<template>
  <v-icon style="margin: 0px;" large :color="prop.color">{{model[`${prop.value}`]}}</v-icon>
</template>

<style scoped>

</style>

<script>
  import CellIcon from "./cellIcon.ts";
  export default CellIcon;
</script>